import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {FotoNasabahSalesComponent} from "./foto-nasabah-sales.component";

const routes: Routes = [
  {
    path: 'foto-nasabah-sales',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: FotoNasabahSalesComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FotoNasabahSalesRoutingModule { }
